import { render, staticRenderFns } from "./categoryTableChannels.vue?vue&type=template&id=73aa178b&scoped=true"
import script from "./categoryTableChannels.vue?vue&type=script&lang=js"
export * from "./categoryTableChannels.vue?vue&type=script&lang=js"
import style0 from "./categoryTableChannels.vue?vue&type=style&index=0&id=73aa178b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa178b",
  null
  
)

export default component.exports